import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';

import TranslatableInput from './inputs/TranslatableInput';

const Text = t(({ id, onChange, values, translate }) => (
  <TranslatableInput
    id={id}
    values={values && values.text}
    options={{ multiline: true, basic: false }}
    label={translate('website.bodyText')}
    name="text"
    onChange={(val) => onChange('text', id, val)}
  />
));

export default Text;
